import React from 'react';
import { t } from '../../../../../i18n';
import './styles.scss';

const GetStartedBlock = () => (
  <div className="home-screen__get-started-block">
    <div className="home-screen__get-started-appeal-wrapper">
      <p className="home-screen__get-started-top-title">{t('DIGITAL_COURSES.HOME_SCREEN.GET_STARTED.TOP_TITLE')}</p>
      <h2 className="home-screen__get-started-main-title">{t('DIGITAL_COURSES.HOME_SCREEN.GET_STARTED.MAIN_TITLE')}</h2>
      <p className="home-screen__get-started-main-information">
        {t('DIGITAL_COURSES.HOME_SCREEN.GET_STARTED.MAIN_INFORMATION')}
      </p>
    </div>
  </div>
);

export default GetStartedBlock;
